import './ShareRoomDialogLinkContent.scss';

import * as React from 'react';

import { useSetAtom } from 'jotai';
import { escape as escapeHtml } from 'lodash';

import { translate } from '~l10n/client';
import { Divider } from '~shared/components/Divider';
import { showConfirmAtom } from '~teacher/components/rooms/ShareRoomDialog/ShareRoomDialog';
import { useRoomDetail } from '~teacher/hook/room/useRoomDetail';

import { ShareRoomLink } from './ShareRoomLink';
import { ShareRoomQrCode } from './ShareRoomQrCode';

interface Props {
  roomId: number;
}

export function ShareRoomDialogContent({ roomId }: Props) {
  const roomDetail = useRoomDetail({
    roomId: roomId,
  });
  const setShowConfirm = useSetAtom(showConfirmAtom);
  const showConfirmReset = () => setShowConfirm(true);
  return (
    <div className="flex flex-col gap-3">
      <div className="my-4">
        <Divider />
      </div>
      <div>
        <span className="text-blue-600 font-sans text-base leading-8">
          {translate(
            'Share this URL with students to give them direct access to this room.'
          )}
        </span>
      </div>
      <div className="flex flex-row gap-4">
        <div className="flex-grow">
          <span
            className="font-sans text-blue-900 text-base break-words leading-8 "
            dangerouslySetInnerHTML={{
              __html: translate(
                'Room link for “<span class=\"room-link-name\">{0}</span>”' /* eslint-disable-line */ /* prettier-ignore */
              ).format(escapeHtml(roomDetail.data?.name)),
            }}
          />
        </div>
      </div>
      <ShareRoomLink roomId={roomId} showConfirmReset={showConfirmReset} />
      <div className="my-4">
        <Divider />
      </div>
      <div className="flex flex-col gap-4">
        <div className="flex-grow">
          <span
            className="font-sans text-blue-900 text-base break-words leading-8 "
            dangerouslySetInnerHTML={{
              __html: translate(
                'QR Code for “<span class=\"room-link-name\">{0}</span>”' /* eslint-disable-line */ /* prettier-ignore */
              ).format(escapeHtml(roomDetail.data?.name)),
            }}
          />
        </div>
        <div>
          <span className="text-blue-600 font-sans text-base leading-8">
            {translate(
              'Share this QR Code with your students. Have them scan the QR with a mobile device to give direct access to this room.'
            )}
          </span>
        </div>
      </div>
      <ShareRoomQrCode roomId={roomId} />
    </div>
  );
}
